import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const MIN_SPLASH = 1000; // keep the loading screen up for at least 1s
    const start = Date.now();
    const finish = () => {
      const wait = Math.max(0, MIN_SPLASH - (Date.now() - start));
      setTimeout(() => setLoading(false), wait);
    };

    const token = sessionStorage.getItem('itsm_token');
    if (token) {
      getMe()
        .then((res) => setUser(res.data))
        .catch(() => {
          sessionStorage.removeItem('itsm_token');
          sessionStorage.removeItem('itsm_user');
        })
        .finally(finish);
    } else {
      finish();
    }
  }, []);

  const loginUser = (token, userData) => {
    sessionStorage.setItem('itsm_token', token);
    sessionStorage.setItem('itsm_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logoutUser = () => {
    sessionStorage.removeItem('itsm_token');
    sessionStorage.removeItem('itsm_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
